import React from 'react'
import { TitleSecondary, SpacerVertical } from 'mage-deps/@klarna/bubble-ui'
import { useHelpContext } from './hooks'
import { Message } from 'mage-i18n'
import { EducationAnalytics } from 'education-tools'
import { OrientationV2 } from '../merchant-orientation'
import RelatedContent from './RelatedContent'
import AllTopicsList from './AllTopicsList'

function HomePage() {
  const { topics } = useHelpContext()

  return (
    <div>
      <EducationAnalytics category="uhqm/page/home" action="pageview" />
      <OrientationV2 />
      <SpacerVertical small />
      <TitleSecondary>
        <Message path="hqm.home.topics" fallback="What do you need help with?" />
      </TitleSecondary>
      <SpacerVertical small />
      <AllTopicsList />
      <SpacerVertical medium />
      <RelatedContent topicSlugs={topics} analyticsCategory="uhqm/article-title/related/home" />
    </div>
  )
}

export default HomePage
